module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-down-regular.8a681f5a.svg";